<template>
<div class="scanner-container">
  <lxm-loading :visible="loading"></lxm-loading>
  <div id="qrCodeScanner" class="scanner"></div>
  <div class="scanner-close" @click="closeScanner" v-show="closeButtonVisible">✕</div>
</div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode'
import * as mTypes from '../../../store/mutation-types'
import LxmLoading from '../../common/LxmLoading.vue'

export default {
  name: 'QrCodeScanner',
  components: {
    LxmLoading
  },
  data () {
    return {
      html5QrCode: null,
      qrCodeResult: null,
      closeButtonVisible: false,
      loading: false
    }
  },
  mounted () {
    this.startScanner()
  },
  beforeDestroy () {
    this.stopScanner()
  },
  methods: {
    startScanner () {
      this.loading = true
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight
      const aspectRatio = (viewportHeight) / viewportWidth
      const config = { fps: 10, qrbox: { width: 280, height: 280 }, aspectRatio: aspectRatio }
      try {
        this.html5QrCode = new Html5Qrcode('qrCodeScanner')
        this.html5QrCode.start(
          { facingMode: 'environment' },
          config,
          this.onScanSuccess,
          this.onScanFailure
        ).then(() => {
          this.loading = false
          this.closeButtonVisible = true
        })
      } catch (err) {
        this.loading = false
      }
    },
    stopScanner () {
      if (this.html5QrCode) {
        this.html5QrCode.stop().then(() => {
          console.log('扫描器已停止')
        }).catch((err) => {
          console.error('无法停止扫描器:', err)
        })
      }
    },
    onScanSuccess (decodedText, decodedResult) {
      this.$store.commit(mTypes.ACTIVITY_SET_SCAN_QRCODE, decodedText)
      this.$store.commit(mTypes.ACTIVITY_SET_SCAN_QRCODE_MODAL_VISIBLE, false)

      this.$emit('scan-code-result')
    },
    onScanFailure (error) {
      console.warn('扫描失败:', error)
    },
    closeScanner () {
      this.$store.commit(mTypes.ACTIVITY_SET_SCAN_QRCODE_MODAL_VISIBLE, false)
    }
  }
}
</script>

<style scoped>
.scanner-container {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.scanner {
  width: 100%;
}
.scanner-close {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: absolute;
  left: 50%;
  bottom: 80px;
  transform: translateX(-50%);
  transition: background-color 0.2s ease;
  z-index: 1;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// QrCodeScanner.vue?6256420e